import React from 'react'
import { accountStepSchema, stepOneSchema } from '../../schemas'
import { Field, Formik } from 'formik'
import { cloneDeep } from 'lodash'
import { useStepStyles } from 'invite/hooks/useStepStyles'
import ContainedButton from 'civic-champs-shared/core/ContainedButton'
import OutlinedButton from 'civic-champs-shared/core/OutlinedButton'
import StyledOutlinedPasswordField from 'civic-champs-shared/formik/components/StyledOutlinedPasswordField'
import StyledOutlinedTextField from 'civic-champs-shared/formik/components/StyledOutlinedTextField'
import StyledOnboardingCheckboxField from 'civic-champs-shared/formik/components/StyledOnboardingCheckboxField'

function StepOne(props) {
  const { invite, onSubmit, children, password, onBack, profile, combinedAccountStep = false } = props
  const classes = useStepStyles()
  const validationSchema = combinedAccountStep ? accountStepSchema : stepOneSchema

  return (
    <>
      {children}
      <Formik
        initialValues={
          combinedAccountStep
            ? {
                givenName: profile.givenName,
                familyName: profile.familyName,
                password: cloneDeep(password),
                passwordConfirm: cloneDeep(password),
                olderThanThirteen: profile.olderThanThirteen,
              }
            : {
                password: cloneDeep(password),
                passwordConfirm: cloneDeep(password),
              }
        }
        validationSchema={validationSchema}
        onSubmit={values => onSubmit(validationSchema.cast(values))}
        validateOnBlur={true}
        validateOnChange={combinedAccountStep}
        enableReinitialize={combinedAccountStep}
      >
        {({ handleSubmit, isSubmitting, isValid, values }) => (
          <form>
            <div className={classes.container}>
              {combinedAccountStep && (
                <>
                  <label className={classes.title}>First Name</label>
                  <div className={classes.field}>
                    <Field
                      fullWidth
                      component={StyledOutlinedTextField}
                      name="givenName"
                      autoCapitalize="on"
                      variant="outlined"
                      marginless
                    />
                  </div>
                  <label className={classes.title}>Last Name</label>
                  <div className={classes.field}>
                    <Field
                      fullWidth
                      component={StyledOutlinedTextField}
                      name="familyName"
                      variant="outlined"
                      marginless
                    />
                  </div>
                </>
              )}
              <label className={classes.title}>{invite.method === 'email' ? 'Email' : 'Phone'}</label>
              <div className={classes.field}>
                <p>{invite.method === 'email' ? invite.person.email : invite.person.phoneNumber}</p>
              </div>
              <label className={classes.title}>Password</label>
              <div className={classes.field}>
                <Field
                  fullWidth
                  component={StyledOutlinedPasswordField}
                  name="password"
                  variant="outlined"
                  marginless
                />
              </div>
              <label className={classes.title}>Confirm Password</label>
              <div className={classes.field} style={{ marginBottom: combinedAccountStep ? undefined : '30px' }}>
                <Field
                  fullWidth
                  component={StyledOutlinedPasswordField}
                  name="passwordConfirm"
                  variant="outlined"
                  marginless
                />
              </div>
              {combinedAccountStep && (
                <div className={classes.field} style={{ marginBottom: '30px' }}>
                  <Field
                    component={StyledOnboardingCheckboxField}
                    name="olderThanThirteen"
                    label="I am 13 years or older"
                  />
                </div>
              )}
              <div className={classes.buttons}>
                <ContainedButton
                  type="submit"
                  disabled={
                    isSubmitting || (combinedAccountStep ? !isValid : !values.password || !values.passwordConfirm)
                  }
                  onClick={handleSubmit}
                >
                  Next
                </ContainedButton>
                {onBack && (
                  <OutlinedButton onClick={onBack} disabled={isSubmitting}>
                    Back
                  </OutlinedButton>
                )}
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  )
}

export default StepOne
